enum CourseStepEnum {
    InitialData = 1,
    Introduction = 2,
    Content = 3,
    Dependency = 4,    
    Finalization = 5
}

export default CourseStepEnum